export const CLEAR_NOTIFICATION = 'Notification/CLEAR_NOTIFICATION';
export const EMPTY_NOTIFICATION = 'Notification/EMPTY_NOTIFICATION';
export const SET_NOTIFICATION = 'Notification/SET_NOTIFICATION';

export const CANCEL_NOTIFICATION_START = 'Notification/CANCEL_NOTIFICATION_START';
export const CANCEL_NOTIFICATION_SUCCESS = 'Notification/CANCEL_NOTIFICATION_SUCCESS';
export const CANCEL_NOTIFICATION_FAILURE = 'Notification/CANCEL_NOTIFICATION_FAILURE';

export const FETCH_NOTIFICATIONS = 'Notification/FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'Notification/FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'Notification/FETCH_NOTIFICATIONS_FAILURE';

export const FETCH_SCHEDULED_NOTIFICATIONS = 'Notification/FETCH_SCHEDULED_NOTIFICATIONS';
export const FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS = 'Notification/FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS';
export const FETCH_SCHEDULED_NOTIFICATIONS_FAILURE = 'Notification/FETCH_SCHEDULED_NOTIFICATIONS_FAILURE';

export const SEND_NOTIFICATION = 'Notification/SEND_NOTIFICATION';
export const SEND_NOTIFICATION_SUCCESS = 'Notification/SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAILURE = 'Notification/SEND_NOTIFICATION_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/store/constants.js